import React from 'react';

import Divider from '@material-ui/core/Divider';

const Item = ({ classes, children }) => {
  return(
    <div>
      {children}
      <Divider />
    </div>
  );
};

export default Item;



// WEBPACK FOOTER //
// ./src/components/Info/Item.jsx